<template>
	<div id="zhuyinggoucheng" class="oh" v-show="hasData">
		<div>
			<div class="w95mg">
				<h4 class="endsm_title1">本地关联企业</h4>
				<vedioTips :type="7" class="fr"></vedioTips>
			</div>
			<div class="land-ecahrt-title w95mg ">
				<span :class="mainTableType == i ? 'current title fl':'title fl'" v-if="localEnterprise[i].length>0"
					v-for="(key,i) in namearry" :key="i" @click="mainTableType=i;">{{key}}</span>
			</div>
			<!-- 供应商的table -->
			<div class="locktable w95mg" v-show="mainTableType=='supplier'">
			<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg"
				v-if="localEnterprise.supplier.length>0" >
				<tr>
					<th class="xuhaotd">序号</th>
					<th>日期</th>
					<th>供应商名称</th>
					<th>地区</th>
					<th>采购额(万元)</th>
					<th>备注</th>
				</tr>
				<tr :key="i" v-for="(item,i) in localEnterprise.supplier" v-if="isFree?i<1:true">
					<td>{{i+1}}</td>
					<td>{{item.yearText}}</td>
					<td>
						<span v-if="item.stockCode == ''">{{item.name}}</span>
						<span v-if="item.stockCode != ''" @click="routerlinkid('/enterprises',item.stockCode)"
							class="curp" :data="item.stockCode">{{item.name}}</span>
					</td>
					<td>{{item.area}}</td>
					<td>{{item.purchaseAmount==""?'-':item.purchaseAmount}}</td>
					<td>
						<span v-show="item.children < 1">-</span>
						<span v-show="item.children.length>0" class="curp"
							@click="supplycustomerMore(item)">全部{{item.children.length+1}}条信息></span>
					</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="1" v-if="isFree"></freeUserTips>
			</div>
			<!-- 客户的table -->
			<div class="locktable w95mg" v-show="mainTableType=='customer'">
			<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg"
				v-if="localEnterprise.customer.length>0" >
				<tr>
					<th class="xuhaotd">序号</th>
					<th>日期</th>
					<th>客户名称</th>
					<th>地区</th>
					<th>销售额(万元)</th>
					<th>备注</th>
				</tr>
				<tr :key="i" v-for="(item,i) in localEnterprise.customer" v-if="isFree?i<1:true">
					<td>{{i+1}}</td>
					<td>{{item.yearText}}</td>
					<td>
						<span v-if="item.stockCode == ''">{{item.name}}</span>
						<span v-if="item.stockCode != ''" @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.name}}</span>
					</td>
					<td>{{item.area}}</td>
					<td>{{item.salesAmount==""?'-':item.salesAmount}}</td>
					<td>
						<span v-show="item.children < 1">-</span>
						<span v-show="item.children.length>0" class="curp"
							@click="supplycustomerMore(item)">全部{{item.children.length+1}}条信息></span>
					</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="1" v-if="isFree"></freeUserTips>
			</div>
			<!-- 对外投资的table --> 
			<div class="locktable w95mg" v-show="mainTableType=='invest'">
			<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg" v-if="localEnterprise.invest.length>0" >
				<tr>
					<th class="xuhaotd">序号</th>
					<th>被投资企业名称</th>
					<th>地区</th>
					<th>法定代表人</th>
					<th>注册资本</th>
					<th>投资比例</th>
					<th>投资数额</th>
					<th>成立时间</th>
					<th>状态</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.invest" v-if="isFree?index<1:true">
					<td>{{index+1}}</td>
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
					<td>{{item.area==""?'':item.area}}</td>
					<td>{{item.legalPerson}}</td>
					<td>{{item.regCapital}}</td>
					<td>{{item.proportion}}%</td>
					<td>{{item.investAmount}}</td>
					<td>{{item.createTime}}</td>
					<td>{{item.status}}</td>
				</tr> 
			</table>
			<freeUserTips :type="2" :bgtype="5" v-if="isFree"></freeUserTips>
			</div>
			<!-- 控制企业的table -->
			<div class="locktable w95mg" v-show="mainTableType=='controllEnterprise'">
			<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg" v-if="localEnterprise.controllEnterprise.length>0" >
				<tr>
					<th class="xuhaotd">序号</th>
					<th>控制企业</th>
					<th>地区</th>
					<th>投资比例</th>
					<th>投资链</th> 
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.controllEnterprise" v-if="isFree?index<1:true" >
					<td>{{index+1}}</td>
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
						<td>{{item.area==""?'-':item.area}}</td>
					<td><span >{{item.proportion}}</span></td>
					<td>
						<span :key="textnum" v-for="(texts,textnum) in item.investChainhtml" class="db tal" v-if="texts!=''" v-html="texts"></span>
					</td> 
				</tr> 
			</table>
			<freeUserTips :type="2" :bgtype="6" v-if="isFree"></freeUserTips>
			</div>
			<!-- 股东信息的table -->
			<div class="locktable w95mg" v-show="mainTableType=='shareholder'">
			<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 w95mg" v-if="localEnterprise.shareholder.length>0" >
				<tr>
					<th class="xuhaotd">序号</th>
					<th>股东及出资信息</th>
					<th>地区</th>
					<th>持股比例</th>
					<th>持股数(股)</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.shareholder" v-if="isFree?index<1:true">
					<td>{{index+1}}</td>
					<td>
						<span v-if="item.stockCode==''" >{{item.name}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.name}}</span>
					</td>
					<td>{{item.area==""?'-':item.area}}</td>
					<td>{{item.value}}%</td>
					<td>{{item.number}}</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="22" v-if="isFree"></freeUserTips>
			</div>
			<!-- 相同投资机构table -->
			<div class="locktable w95mg" v-show="mainTableType=='investOrg'">
			<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 w95mg" v-if="localEnterprise.investOrg.length>0" >
				<tr>
					<th class="xuhaotd">序号</th> 
					<th>企业名称</th>
					<th>投资机构名称</th>
					<th>注册资本</th>
					<th>所属行业</th>
					<th>所属城市</th>
					<th>详细地址</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.investOrg" v-if="isFree?index<1:true">
					<td>{{index+1}}</td> 
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
					<td><span @click="routerlinkid('/investement-enterprises',item.middleId)" class="curs-pointer hover-base">{{item.middleName}}</span></td>
					<td>{{item.regCapital}}</td>
					<td>{{item.industry}}</td>
					<td>{{item.area || ''}}</td>
					<td>{{item.address || ''}}</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="23" v-if="isFree"></freeUserTips>
			</div>
			<!-- 相同协会table -->
			<div class="locktable w95mg" v-show="mainTableType=='association'">
			<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 w95mg" v-if="localEnterprise.association.length>0">
				<tr>
					<th class="xuhaotd">序号</th> 
					<th>企业名称</th>
					<th>协会名称</th>
					<th>注册资本</th>
					<th>所属行业</th>
					<th>所属城市</th>
					<th>详细地址</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.association" v-if="isFree?index<1:true">
					<td>{{index+1}}</td> 
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
					<td><span @click="routerlinkid('/associationDetail',item.middleId)" class="curs-pointer hover-base">{{item.middleName}}</span></td>
					<td>{{item.regCapital}}</td>
					<td>{{item.industry}}</td>
					<td>{{item.area || ''}}</td>
					<td>{{item.address || ''}}</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="24" v-if="isFree"></freeUserTips>
			</div>
			<!-- 相同商会table -->
			<div class="locktable w95mg" v-show="mainTableType=='commerce'">
			<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 w95mg" v-if="localEnterprise.commerce.length>0" >
				<tr>
					<th class="xuhaotd">序号</th> 
					<th>企业名称</th>
						<th>商会名称</th>
					<th>注册资本</th>
					<th>所属行业</th>
					<th>所属城市</th>
					<th>详细地址</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.commerce" v-if="isFree?index<1:true">
					<td>{{index+1}}</td> 
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
					<td><span @click="routerlinkid('/commerceDetail',item.middleId)" class="curs-pointer hover-base">{{item.middleName}}</span></td>
					<td>{{item.regCapital}}</td>
					<td>{{item.industry}}</td>
					<td>{{item.area || ''}}</td>
					<td>{{item.address || ''}}</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="25" v-if="isFree"></freeUserTips>
			</div>
				<!-- 相同高管table -->
			<div class="locktable w95mg" v-show="mainTableType=='keyPersonal'">
			<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 w95mg" v-if="localEnterprise.keyPersonal.length>0" >
				<tr>
					<th class="xuhaotd">序号</th> 
					<th>企业名称</th>
					<th>高管</th>
					<th>注册资本</th>
					<th>所属行业</th>
					<th>所属城市</th>
					<th>详细地址</th>
				</tr>
				<tr :key="index" v-for="(item,index) in localEnterprise.keyPersonal" v-if="isFree?index<1:true">
					<td>{{index+1}}</td> 
					<td>
						<span v-if="item.stockCode==''" >{{item.title}}</span>
						<span v-if="item.stockCode!=''"  @click="routerlinkid('/enterprises',item.stockCode)" class="curp" :data="item.stockCode">{{item.title}}</span>
					</td>
					<td><span>{{item.middleName}}</span></td>
					<td>{{item.regCapital}}</td>
					<td>{{item.industry}}</td>
					<td>{{item.area || ''}}</td>
					<td>{{item.address || ''}}</td>
				</tr>
			</table>
			<freeUserTips :type="2" :bgtype="25" v-if="isFree"></freeUserTips>
			</div>
		</div>
	</div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"

	export default {
		name: 'localRelateEnterprise',
		data() {
			return {
				titleh: "企业详情页--本地相关企业",
				localEnterprise: {
					supplier: {},
					customer: {},
					invest: {},
					controllEnterprise: {},
					shareholder: {},
					investOrg: [],
					commerce: [],
					association:[],
					keyPersonal:[],
				},
				hasData:false,
				mainTableType: 'supplier',
				tablelist: [],
				namearry: {
					supplier: '供应商',
					customer: '客户',
					invest: '对外投资',
					controllEnterprise: '控制企业',
					shareholder: '股东',
					investOrg: '相同投资机构',
					commerce: '相同商会',
					association:'相同协会',
					keyPersonal:"相同高管"
				},
			}
		},
		props: {
			compData: {
				type: Object
			},
			isFree: {
				type: Boolean,
				default: false
			},
			currentCity: {},
		},
		components:{freeUserTips},
		created() {
			// this.localEnterprise = this.compData;
		},
		mounted() {
			this.localEnterprise.supplier = this.suplierCustoFun('供应商', this.compData.supplier); //供应商
			this.localEnterprise.customer = this.suplierCustoFun('客户', this.compData.customer); //客户 
			this.localEnterprise.invest = this.sortKey(this.compData.invest,'createTime');//对外投资
			this.localEnterprise.controllEnterprise = this.controllEnterprisefun(this.compData.controllEnterprise);//控制企业
			this.localEnterprise.shareholder =this.compData.shareholder;//股东 
			this.localEnterprise.association =this.compData.association;//协会 
			this.localEnterprise.commerce =this.compData.commerce;//商会 
			this.localEnterprise.investOrg =this.compData.investOrg;//投资机构 
			this.localEnterprise.keyPersonal =this.compData.keyPersonal;//相同高管 
			
			for(var key in this.localEnterprise){ 
				console.log(this.localEnterprise[key],key);
				let len = this.localEnterprise[key].length;
				if(len>0){
					this.hasData=true;
					this.mainTableType=key;
					break;
				} 
			}
		},
		methods: {
			//供应商客户信息处理
			suplierCustoFun(name, data) { 
				for (var i = 0; i < data.length; i++) {
					data[i].children = [];
					data[i].isrepeat = false;
				}
				for (var i = 0; i < data.length; i++) {
					var dataname = data[i].name;
					for (var d = i + 1; d < data.length; d++) {
						var dataname1 = data[d].name;
						if (dataname == dataname1 && !data[i].isrepeat) { 
							if (data[i].stockCode == '') {
								data[i].stockCode = data[d].stockCode;
							}
							data[i].children.push(data[d]);
							data[d].isrepeat = true; 
						}
					}
				}
				var dds = data.filter(list => {
					return !list.isrepeat;
				})
				// console.log('suplierCustoFuna' + name, dds);
				return dds;
			},
			sortKey(array,key){//正序从大到小
				return array.sort(function(a,b){
					var x = a[key];
					var y = b[key];
					return ((x>y)?-1:(x<y)?1:0)
				})
			},
			//控制企业信息处理
			controllEnterprisefun(data){ 
				for(var i=0;i<data.length;i++){
					let tds=data[i].investChain; 
					data[i].investChainhtml=tds.split('路径');
					 var proportionnum=data[i].proportion;
						if(proportionnum.indexOf('%')<0){
							data[i].proportion=data[i].proportion*100+'%';
						}
					for(var d=0;d<data[i].investChainhtml.length;d++){
						if(data[i].investChainhtml[d]!=""){
							let ddsttss=data[i].investChainhtml[d];
							ddsttss="<b>路径"+ddsttss;
							var indst=ddsttss.indexOf('%）')+2;
							data[i].investChainhtml[d]=ddsttss.slice(0, indst) + '</b>' + ddsttss.slice(indst); 
						} 
					} 
				}  
				// console.log('controllEnterprisefun控制企业',data[7],data[8])
		 return data;
			}, 
		}
	};
</script>

<style lang="scss" scoped>
	.pagetable1 {
		margin-bottom: 20px;
	}

	.endsm_title1 {
		border-left: 8px solid #3e7bfa;
		line-height: 20px;
		padding-left: 14px;
		margin: 30px 0 30px;
	}

	#mainPieProduct,
	#mainPieArea,
	#mainPieHy {
		width: 30%;
		height: 400px;
		background: #fff;
		border: 1px solid #eee;
	}

	.curTableDate {
		width: 150px;
		margin-left: 100px;
	}
 
</style>